import { combineReducers } from 'redux'

import {
  AiAutomationBehaviorInitialState,
  AiAutomationBehaviorReducer,
} from 'apps/aiAutomation/store/behavior'
import { AiAutomationBehaviorState } from 'apps/aiAutomation/store/behavior/lib/types'
import {
  AiAlwaysOnAutomationsReducer,
  AiAutomationCoreInitialState,
} from 'apps/aiAutomation/store/core'
import { AiAutomationCoreState } from 'apps/aiAutomation/store/core/lib/types'
import {
  AiAutomationEngagementGoalInitialState,
  AiAutomationEngagementGoalReducer,
  AiAutomationEngagementGoalState,
} from 'apps/aiAutomation/store/engagementGoal'
import { InstantAnswersPlaygroundReducer } from 'apps/aiAutomation/store/instantAnswersPlayground'
import {
  InstantAnswersPlaygroundInitialState,
  InstantAnswersPlaygroundState,
} from 'apps/aiAutomation/store/instantAnswersPlayground/types'
import {
  AiAutomationKnowledgeInitialState,
  AiAutomationKnowledgeReducer,
  AiAutomationKnowledgeState,
} from 'apps/aiAutomation/store/knowledge'
import { AiAutomationLayoutReducer } from 'apps/aiAutomation/store/layout'
import { AiAutomationLayoutInitialState } from 'apps/aiAutomation/store/layout/lib'
import { AiAutomationLayoutState } from 'apps/aiAutomation/store/layout/types'
import { LeadQualPlaygroundReducer } from 'apps/aiAutomation/store/leadQualPlayground'
import {
  LeadQualPlaygroundInitialState,
  LeadQualPlaygroundState,
} from 'apps/aiAutomation/store/leadQualPlayground/types'
import {
  AiAutomationStatsInitialState,
  AiAutomationStatsReducer,
} from 'apps/aiAutomation/store/stats'
import { AiAutomationStatsState } from 'apps/aiAutomation/store/stats/lib/types'
import {
  AiAutomationToneOfVoiceInitialState,
  AiAutomationToneOfVoiceReducer,
} from 'apps/aiAutomation/store/toneOfVoice'
import { AiAutomationToneOfVoiceState } from 'apps/aiAutomation/store/toneOfVoice/lib/types'
import { UniversalPlaygroundReducer } from 'apps/aiAutomation/store/universalPlayground'
import {
  UniversalPlaygroundInitialState,
  UniversalPlaygroundState,
} from 'apps/aiAutomation/store/universalPlayground/types'

export { aiAutomationResetAll } from './actions'

export const aiAutomationReducer = combineReducers({
  core: AiAlwaysOnAutomationsReducer,
  instantAnswersPlayground: InstantAnswersPlaygroundReducer,
  stats: AiAutomationStatsReducer,
  knowledge: AiAutomationKnowledgeReducer,
  engagementGoal: AiAutomationEngagementGoalReducer,
  leadQualPlayground: LeadQualPlaygroundReducer,
  layout: AiAutomationLayoutReducer,
  toneOfVoice: AiAutomationToneOfVoiceReducer,
  universalPlayground: UniversalPlaygroundReducer,
  behavior: AiAutomationBehaviorReducer,
})

export interface AiAutomationState {
  core: AiAutomationCoreState
  instantAnswersPlayground: InstantAnswersPlaygroundState
  stats: AiAutomationStatsState
  knowledge: AiAutomationKnowledgeState
  engagementGoal: AiAutomationEngagementGoalState
  leadQualPlayground: LeadQualPlaygroundState
  layout: AiAutomationLayoutState
  toneOfVoice: AiAutomationToneOfVoiceState
  universalPlayground: UniversalPlaygroundState
  behavior: AiAutomationBehaviorState
}

export const AiAutomationInitialState = {
  core: AiAutomationCoreInitialState,
  instantAnswersPlayground: InstantAnswersPlaygroundInitialState,
  stats: AiAutomationStatsInitialState,
  knowledge: AiAutomationKnowledgeInitialState,
  engagementGoal: AiAutomationEngagementGoalInitialState,
  leadQualPlayground: LeadQualPlaygroundInitialState,
  layout: AiAutomationLayoutInitialState,
  toneOfVoice: AiAutomationToneOfVoiceInitialState,
  universalPlayground: UniversalPlaygroundInitialState,
  behavior: AiAutomationBehaviorInitialState,
}
